var React = require('react');

function IconAttentionSolid (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M693.3 148.8c-62.3 0-112.2 22.4-156.2 66.4 0 0-.1 0-.1.1l-25 31.5-25-29.6-.1-.1c-44-44-93.9-68.3-156.2-68.3s-120.8 24.3-164.9 68.3c-44 44.1-68.3 102.6-68.3 164.9 0 62.2 24.2 120.8 68.2 164.8L475.1 859c9.7 9.8 23 15.3 36.8 15.3 13.8 0 27.1-5.5 36.8-15.3l309.5-312.1c44-44.1 68.2-102.6 68.2-164.8 0-62.3-24.3-120.8-68.3-164.9-43.9-44.1-102.5-68.4-164.8-68.4z"}));
}

IconAttentionSolid.displayName = "IconAttentionSolid";

IconAttentionSolid.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconAttentionSolid;

IconAttentionSolid.default = IconAttentionSolid;
